import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/core/styles";
import { useStaticQuery, graphql } from "gatsby";
import { CssBaseline } from "@material-ui/core";
import Helmet from "react-helmet";
import { useIsClient } from "../hooks";
import { ApolloWrapper } from "../apollo/apolloWrapper";
import Sidebar from "./Sidebar";
import theme from "./theme";
import "../assets/styles/global.scss";

const Layout = ({ children }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          socials
          email
        }
      }
    }
  `);
  const { isClient, key } = useIsClient();
  if (!isClient) return null;

  return (
    <React.Fragment key={key}>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
        />
      </Helmet>
      <ThemeProvider theme={theme}>
        <ApolloWrapper>
          <CssBaseline />
          <Sidebar siteMetadata={site.siteMetadata} />
          <main>{children}</main>
        </ApolloWrapper>
      </ThemeProvider>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
